<template>
  <div v-if="viewMCGEmployeeYearAwardsCountReport" class="report-ve-awards">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="alert alert-info">
          <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
            <span v-html="showHideFilterText"></span>
          </button>
          <div class="mr-2 float-right">
            Download current view as:
            <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
            </button>
          </div>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-4 mb-2">
                <label>Nomination Category</label>
                <select v-model="nominationCategorySelect" v-on:change="loadNominations()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 mb-2">
                <label for="nominatorFilter">From Date:</label>
                <div class="input-group">
                  <!--input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="dateFilters()" /-->
                  <template>
                    <div style="position: relative;">
                      <label for="begin" style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                        {{ formattedFromDate }}
                      </label>
                      <input type="date" ref="datepicker"
                        :value="fromDate" :min="minDate" :max="maxDate"
                        @input="updateFromDate" @blur="hideDatepicker" v-on:change="dateFilters()"
                        style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                      />
                    </div><BR/>
                  </template>
                </div>
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">To Date:</label>
                <div class="input-group">
                  <template>
                    <div style="position: relative;">
                      <label
                        for="end"
                        style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                        {{ formattedToDate }}
                      </label>
                      <input
                        type="date"
                        ref="datepicker"
                        :value="toDate"
                        :min="minDate"
                        :max="maxDate"
                        @input="updateToDate"
                        @blur="hideDatepicker"
                        v-on:change="dateFilters()"
                        style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                      />
                    </div><BR/>
                  </template>
                </div>
              </div>
            </div>
          </b-collapse>
          <hr><hr>
        </div>
        <NominationMCGEmployeeReportEntries v-if="nominations.length > 0" :nominations="nominations"></NominationMCGEmployeeReportEntries>
        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="changeItemPerPage()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <iframe id="iFramePdf" src="myPdfUrl.pdf" style="display:none;"></iframe>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import NominationMCGEmployeeReportEntries from '@/components/NominationMCGEmployeeReportEntries'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
import {BCard, BTabs, BTab, BPagination, BCollapse} from 'bootstrap-vue'

import 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    NominationMCGEmployeeReportEntries,
    'b-card': BCard,
    'b-tabs': BTabs,
    'b-tab': BTab,
    'b-pagination': BPagination,
    'b-collapse': BCollapse
  },
  data () {
    return {
      nominations: [],
      totalNominations: [],
      totalPaginationNominations: [],
      unfilteredNominations: [],
      contentReady: false,
      contentLoadError: '',
      graduatedNominationsCheck: false,
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      nominationApproverSelect: '-- All --',
      nominatorFilter: '',
      nominatorFilterButton: '+',
      nomineeFilter: '',
      nomineeFilterButton: '+',
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10,
      toDate: '',
      fromDate: '',
      userType: 'HRBP',
      minDate: '',
      maxDate: '',
      BUOptions: [],
      selectedBUOption: 'Select BU',
      showMaxValCount : 0,
      DMSValCount : 0,
      GEValCount : 0,
      MAHValCount : 0,
      MCSAValCount : 0,
      SuperSportValCount : 0,
      GroupTechValCount : 0,
      SupportFunctionsValCount : 0,
      showMaxOption1ValCount : 0,
      DMSOption1ValCount : 0,
      GEOption1ValCount : 0,
      MAHOption1ValCount : 0,
      MCSAOption1ValCount : 0,
      SuperSportOption1ValCount : 0,
      GroupTechOption1ValCount : 0,
      SupportFunctionsOption1ValCount : 0,
      showMaxOption2ValCount : 0,
      DMSOption2ValCount : 0,
      GEOption2ValCount : 0,
      MAHOption2ValCount : 0,
      MCSAOption2ValCount : 0,
      SuperSportOption2ValCount : 0,
      GroupTechOption2ValCount : 0,
      SupportFunctionsOption2ValCount : 0
    }
  },
  computed: {
    formattedFromDate() {
      if (!this.fromDate) return ''
      const date = new Date(this.fromDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return this.fromDate
    },
    formattedToDate() {
      if (!this.toDate) return ''
      const date = new Date(this.toDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return this.toDate
    },
    ...mapGetters([
      'viewMCGEmployeeYearAwardsCountReport'
    ])
  },
  created () {  

    var self = this
    var usernameOptions = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
      .then(function (userResponse) {
        self.userDetails = userResponse.data
        if (self.userDetails) {
          console.log(' self.userDetails ', self.userDetails)
          console.log(' self.userDetails ', self.userDetails.email)

          console.log('created')
          const today = new Date()
          const year = today.getFullYear()
          //const month = today.getMonth() + 1 // Adding 1 since January is 0
          const month = 4
          const day = today.getDate()
          const financialYear = month < 4 ? year - 1 : year
          const formattedDate = `${financialYear}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
          const financialYearStart = month < 4 ? year - 1 : year
          const minDate = `${financialYearStart}-04-01`
          const maxDate = `${financialYearStart + 1}-03-31`

          self.toDate = maxDate
          self.fromDate = minDate

          self.minDate = minDate
          self.maxDate = maxDate
          console.log(' loadNominations ')

          console.log('profile UD-> ', self.userDetails)
          document.title = self.$route.name + ' - ThinkTank'
          WordpressRestAPI.getViewContent('nomination_event_category?per_page=100')
            .then(response => {
              self.nominationCategories = response.data.filter(x => x.id == 140)
              self.loadNominations()
            })
            .catch(e => {
              console.error(e)
            })

        }
    })
    .catch(e => {
        console.error(e)
    })
  },
  methods: {
    showDatepicker() {
      this.showDatepickerFlag = true;
      this.$nextTick(() => {
        this.$refs.datepicker.focus();
      });
    },
    updateFromDate(event) {
      this.fromDate = event.target.value;
      this.$emit('change', this.fromDate);
      this.showDatepicker = false;
    },
    updateToDate(event) {
      this.toDate = event.target.value;
      this.$emit('change', this.toDate);
      this.showDatepicker = false;
    },
    hideDatepicker() {
      setTimeout(() => {
        this.showDatepicker = false;
      }, 200000); // delay to allow date selection before hiding
    },
    validateDates: function() {
      if (this.$refs.toDate)
        this.toDate = this.$refs.toDate.value

      if (this.$refs.fromDate)
        this.fromDate = this.$refs.fromDate.value

      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1 // Adding 1 since January is 0
      const financialYearStart = month < 4 ? year - 1 : year
      const minDate = new Date(`${financialYearStart}-04-01`)
      const maxDate = new Date(`${financialYearStart + 1}-03-31`)

      const fromDate = new Date(this.fromDate)

      if (fromDate < minDate || fromDate > maxDate) {
        this.fromDate = `${financialYearStart}-04-01`
        alert('Please select date in current Financial Year')
        return false
      }
      const toDate = new Date(this.toDate)
      if (toDate < minDate || toDate > maxDate) {
        this.toDate = `${financialYearStart + 1}-03-31`
        alert('Please select date in current Financial Year to Date')
        return false
      }

      if (toDate < fromDate) {
        alert('To Date should be greater than From Date')
        this.fromDate = `${financialYearStart}-04-01`
        this.toDate =   `${financialYearStart + 1}-03-31`
        return false
      }

      if ( this.toDate !== '' && this.fromDate !== '') {
        return '&after=' + this.fromDate + ' 00:00:00&before=' + this.toDate + ' 23:59:59'
      }
      return false
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/ /g, ' ').replace(/ /g, ' ').replace(/ /g, ' ')
          exportData[header] = value
        }
      })
      return exportData
    },
    getSingleNomineeInfo: function (x) {
      var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': [], 'department': [], 'projectSponsor': '', 'projectSponsorApproved': '', 'projectSponsorDeclinedReason': '', 'projectSponsorDate': '' }
      nomineesInfo.nomineeName = x.nominee_name[0]
      nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber[0]
      nomineesInfo.nomineeEmail = x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.')
      nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
      nomineesInfo.businessUnit = ' '
      nomineesInfo.country = ' '
      nomineesInfo.gom = ' '
      nomineesInfo.department = ''
      if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
        nomineesInfo.nomineeEmail = x.nominee_slug[1]
        nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
        nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
        nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
        nomineesInfo.department = 'departmentname' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.departmentname[0] : ''
        if ('employeenumber' in x.nominee_slug.employeehierarchy)
          nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
      }
      return nomineesInfo
    },
    getNomineeInfo: function (nomineesInfo, x, i, count) {
      nomineesInfo.nomineeName += (count - 1 === i) ? x.member_name : x.member_name + ' $&$ '
      var nomineeEmployeNumber = (count - 1 === i) ? x.member_employee_number : x.member_employee_number + ' $&$ '
      nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '
      var employeeNumberflag = true
      if (x.member_email.indexOf('@') > -1 && 'businessunit' in x.employeehierarchy) {
        nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_email : x.member_email + ' $&$ '
        nomineesInfo.businessUnit += (count - 1 === i) ? x.employeehierarchy.businessunit[0] : x.employeehierarchy.businessunit[0] + ' $&$ '
        nomineesInfo.country += (count - 1 === i) ? x.employeehierarchy.country[0] : x.employeehierarchy.country[0] + ' $&$ '
        nomineesInfo.gom += (count - 1 === i) ? x.employeehierarchy.gom[0] : x.employeehierarchy.gom[0] + ' $&$ '
        if ('employeenumber' in x.employeehierarchy) {
          employeeNumberflag = false
          nomineesInfo.nomineeEmployeNumber += (count - 1 === i) ? x.employeehierarchy.employeenumber[0] : x.employeehierarchy.employeenumber[0] + ' $&$ '
        }
      }
      else {
        nomineesInfo.gom = nomineesInfo.nomineeCompany
        nomineesInfo.businessUnit += (count - 1 === i) ? ' '  : '  $&$ '
        nomineesInfo.country += (count - 1 === i) ? ' '  : '  $&$ '
        var emailCreator = ''
        var emailCreatorName = ''
        emailCreator = x.member_name.replace(/ /g, '.') + '@'
        emailCreatorName = x.member_name.toLowerCase().replace(/ /g, '-')
        emailCreator = x.member_slug.replace(emailCreatorName, emailCreator).replace(/-/g, '.')
        if (x.member_company.toLowerCase().indexOf('multichoice') > -1) {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? emailCreator : emailCreator + ' $&$ '
        } else {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') + ' $&$ '
        }
      }
      if (employeeNumberflag == true)
        nomineesInfo.nomineeEmployeNumber += nomineeEmployeNumber
      return nomineesInfo
    },
    exportTeamData: function (teamDetails) {
      var self = this
      var nomineesInfo = {'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': []}
      var count = teamDetails.length
      if (count > 1) {
        teamDetails.map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      } else {
        teamDetails[0].map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      }
      return nomineesInfo
    },
    getDateTime: function (val, needle, index) {
      if(val !== undefined && val !== null && val !== "" && val !== "NA") {
        return val.split(needle)[index]
      } else {
        return ''
      }
    },
    initialize() {
      this.showMaxValCount = 0,
      this.DMSValCount = 0,
      this.GEValCount = 0,
      this.MAHValCount = 0,
      this.MCSAValCount = 0,
      this.SuperSportValCount = 0,
      this.GroupTechValCount = 0,
      this.SupportFunctionsValCount = 0,
      this.showMaxOption1ValCount = 0,
      this.DMSOption1ValCount = 0,
      this.GEOption1ValCount = 0,
      this.MAHOption1ValCount = 0,
      this.MCSAOption1ValCount = 0,
      this.SuperSportOption1ValCount = 0,
      this.GroupTechOption1ValCount = 0,
      this.SupportFunctionsOption1ValCount = 0,
      this.showMaxOption2ValCount = 0,
      this.DMSOption2ValCount = 0,
      this.GEOption2ValCount = 0,
      this.MAHOption2ValCount = 0,
      this.MCSAOption2ValCount = 0,
      this.SuperSportOption2ValCount = 0,
      this.GroupTechOption2ValCount = 0,
      this.SupportFunctionsOption2ValCount = 0
    },
    exportToCSV: function () {
      this.initialize()
      var self = this
      if (self.fromDate && self.toDate) {
        // Map fields of nominations array that will be converted to CSV
        const items1 = this.nominations.map(function (x) {
          console.log('exportToCSV x ', x)
          var splitData = {}
          var nomineesDetails = {}
          var showMaxVal = ''
          var DMSVal = ''
          var GEVal = ''
          var MAHVal = ''
          var MCSAVal = ''
          var SuperSportVal = ''
          var GroupTechVal = ''
          var SupportFunctionsVal = ''
          var TotalVal = ''

          if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
            nomineesDetails = self.exportTeamData(x.nominationteam[0])
            console.log('404 ', nomineesDetails)
          } else {
            nomineesDetails = self.getSingleNomineeInfo(x)
            console.log('474 ', nomineesDetails)
          }

          if (nomineesDetails && typeof nomineesDetails.nomineeName === 'string') {
            var nomineeNameRaw = nomineesDetails.nomineeName
          } else {
            var nomineeNameRaw = ''
          }

          var nomineeNameCount = nomineeNameRaw.split(' $&$ ')
          // Ensure it always has at least 3 entries
          while (nomineeNameCount.length < 3) {
            nomineeNameCount.push('')
          }
          var GOMList =  (x.MCGEOYOption1 && x.MCGEOYOption1[0] && x.MCGEOYOption1[0].GOM || '') + ' $&$ ' +  
          (x.MCGEOYOption2 && x.MCGEOYOption2[0] && x.MCGEOYOption2[0].GOM || '') + ' $&$ ' +  
          (x.MCGEOYOption3 && x.MCGEOYOption3[0] && x.MCGEOYOption3[0].GOM || '')
          console.log(' GOMList ', GOMList)

          if (x.MCGEOYOption1 && x.MCGEOYOption1[0] && x.MCGEOYOption1[0].GOM) {
            if (x.MCGEOYOption1[0].GOM == 'Showmax') {
              var showMaxVal = 'Option 1'
              self.showMaxValCount++
              self.showMaxOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'Technology') {
              var GroupTechVal = 'Option 1'
              self.GroupTechValCount++
              self.GroupTechOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'MAH') {
              var MAHVal = 'Option 1'
              self.MAHValCount++
              self.MAHOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'DSTV Media Sales') {
              var DMSVal = 'Option 1'
              self.DMSValCount++
              self.DMSOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'General Entertainment') {
              var GEVal = 'Option 1'
              self.GEValCount++
              self.GEOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'MCSA') {
              var MCSAVal = 'Option 1'
              self.MCSAValCount++
              self.MCSAOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'SuperSport') {
              var SuperSportVal = 'Option 1'
              self.SuperSportValCount++
              self.SuperSportOption1ValCount++
            }
            if (x.MCGEOYOption1[0].GOM == 'Support Functions') {
              var SupportFunctionsVal = 'Option 1'
              self.SupportFunctionsValCount++
              self.SupportFunctionsOption1ValCount++
            }
          }

          if (x.MCGEOYOption2 && x.MCGEOYOption2[0] && x.MCGEOYOption2[0].GOM) {
            if (x.MCGEOYOption2[0].GOM == 'Showmax') {
              var showMaxVal = 'Option 2'
              self.showMaxValCount++
              self.showMaxOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'Technology') {
              var GroupTechVal = 'Option 2'
              self.GroupTechValCount++
              self.GroupTechOption2ValCount++
            }                    
            if (x.MCGEOYOption2[0].GOM == 'MAH') {
              var MAHVal = 'Option 2'
              self.MAHValCount++
              self.MAHOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'DSTV Media Sales') {
              var DMSVal = 'Option 2'
              self.DMSValCount++
              self.DMSOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'General Entertainment') {
              var GEVal = 'Option 2'
              self.GEValCount++
              self.GEOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'MCSA') {
              var MCSAVal = 'Option 2'
              self.MCSAValCount++
              self.MCSAOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'SuperSport') {
              var SuperSportVal = 'Option 2'
              self.SuperSportValCount++
              self.SuperSportOption2ValCount++
            }
            if (x.MCGEOYOption2[0].GOM == 'Support Functions') {
              var SupportFunctionsVal = 'Option 2'
              self.SupportFunctionsValCount++
              self.SupportFunctionsOption2ValCount++
            }
          }

          if (x.MCGEOYOption3 && x.MCGEOYOption3[0] && x.MCGEOYOption3[0].GOM) {
            if (x.MCGEOYOption3[0].GOM == 'Showmax') {
              var showMaxVal = 'Option 3'
              self.showMaxValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'Technology') {
              var GroupTechVal = 'Option 3'
              self.GroupTechValCount++
            }                    
            if (x.MCGEOYOption3[0].GOM == 'MAH') {
              var MAHVal = 'Option 3'
              self.MAHValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'DSTV Media Sales') {
              var DMSVal = 'Option 3'
              self.DMSValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'General Entertainment') {
              var GEVal = 'Option 3'
              self.GEValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'MCSA') {
              var MCSAVal = 'Option 3'
              self.MCSAValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'SuperSport') {
              var SuperSportVal = 'Option 3'
              self.SuperSportValCount++
            }
            if (x.MCGEOYOption3[0].GOM == 'Support Functions') {
              var SupportFunctionsVal = 'Option 3'
              self.SupportFunctionsValCount++
            }
          }

          const temp = Object.assign({}, {
            Nominator_Name: x._embedded.author[0].name,
            'ShowMax' : showMaxVal,
            'DMS' : DMSVal,
            'GE' : GEVal,
            'MAH' : MAHVal,
            'MCSA' : MCSAVal,
            'SuperSport' : SuperSportVal,
            'Group Tech' : GroupTechVal,
            'Support Functions' : SupportFunctionsVal,
            'Total' : TotalVal 
          }, splitData)
          return temp
        })

        const items2 = Array.from({ length: 1 }, (_, i) => {
          var splitData = {}
          self.TotalVal = self.showMaxValCount + 
            self.DMSValCount +
            self.GEValCount +
            self.MAHValCount +
            self.MCSAValCount +
            self.SuperSportValCount +
            self.GroupTechValCount +
            self.SupportFunctionsValCount

          const temp = Object.assign({}, {
            Nominator_Name: 'Number of votes', // replace with actual value if needed
            'ShowMax': self.showMaxValCount,
            'DMS': self.DMSValCount,
            'GE': self.GEValCount,
            'MAH': self.MAHValCount,
            'MCSA': self.MCSAValCount,
            'SuperSport': self.SuperSportValCount,
            'Group Tech': self.GroupTechValCount,
            'Support Functions': self.SupportFunctionsValCount,
            'Total': self.TotalVal
          }, splitData)
          return temp
        })

        const items3 = Array.from({ length: 1 }, (_, i) => {
          var splitData = {}
        
          const temp = Object.assign({}, {
            Nominator_Name: 'Option 1', // replace with actual value if needed
            'ShowMax': self.showMaxOption1ValCount,
            'DMS': self.DMSOption1ValCount,
            'GE': self.GEOption1ValCount,
            'MAH': self.MAHOption1ValCount,
            'MCSA': self.MCSAOption1ValCount,
            'SuperSport': self.SuperSportOption1ValCount,
            'Group Tech': self.GroupTechOption1ValCount,
            'Support Functions': self.SupportFunctionsOption1ValCount,
            'Total': ''
          }, splitData)
          return temp
        })

        let topValues = self.getTopThreeValuesnew()
        console.log(' topValues 736 ', topValues)

        // Create a map of all variables with default ""
        let winners = {
          showMax: '',
          DMS: '',
          GE: '',
          MAH: '',
          MCSA: '',
          SuperSport: '',
          GroupTech: '',
          SupportFunctions: ''
        };

        if (Array.isArray(topValues) && topValues.length) {
          topValues.forEach(item => {
            winners[item.name] = `Winner ${item.rank}`;
          });
        }
        console.log(' 649 winners ', winners)
        const items4 = Array.from({ length: 1 }, (_, i) => {
          var splitData = {}

          const temp = Object.assign({}, {
            Nominator_Name: 'Option 2 (tie breaker - most voted option 2)', // replace with actual value if needed
            'ShowMax': self.showMaxOption2ValCount,
            'DMS': self.DMSOption2ValCount,
            'GE': self.GEOption2ValCount,
            'MAH': self.MAHOption2ValCount,
            'MCSA': self.MCSAOption2ValCount,
            'SuperSport': self.SuperSportOption2ValCount,
            'Group Tech': self.GroupTechOption2ValCount,
            'Support Functions': self.SupportFunctionsOption2ValCount,
            'Total': ''
          }, splitData)
          return temp
        })

        console.log("Winners: 768", winners)
        const items5 = [{
          Nominator_Name: '3 MCG Overall Winners',
          'ShowMax': winners.showMax,
          'DMS': winners.DMS,
          'GE': winners.GE,
          'MAH': winners.MAH,
          'MCSA': winners.MCSA,
          'SuperSport': winners.SuperSport,
          'Group Tech': winners.GroupTech,
          'Support Functions': winners.SupportFunctions,
          'Total': ''
        }]

        console.log(' 577 ', items5)
        //const items = Object.assign({}, items1, items2)
        //const items = items1
        const items = [...items1, ...items2, ...items3, ...items4, ...items5]
        console.log(' merged ', items)
        var keysOnly = []
        for (var k = 0; k < items.length; k++) {
          //console.log(' k ', k, items[k])
          keysOnly = keysOnly.concat(Object.keys(items[k]))
        }
        console.log(' keysOnly ', keysOnly)
        let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
        console.log(' csvKeys ', csvKeys)
        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < csvKeys.length; j++) {
            if (items[i][csvKeys[j]]) {
              items[i][csvKeys[j]] = items[i][csvKeys[j]]
            } else {
              items[i][csvKeys[j]] = ''
            }
          }
        }
        // Convert to JSON and then create CSV file for download
        console.log('items', items)
        ExportToCSV.createCSV(items, 'Recognition')
      } else {
        alert('Please select date range')
      }
    },
    getTopThreeValuesnew() {
      const values = {
        showMax: {
          option1: this.showMaxOption1ValCount,
          option2: this.showMaxOption2ValCount
        },
        DMS: {
          option1: this.DMSOption1ValCount,
          option2: this.DMSOption2ValCount
        },
        GE: {
          option1: this.GEOption1ValCount,
          option2: this.GEOption2ValCount
        },
        MAH: {
          option1: this.MAHOption1ValCount,
          option2: this.MAHOption2ValCount
        },
        MCSA: {
          option1: this.MCSAOption1ValCount,
          option2: this.MCSAOption2ValCount
        },
        SuperSport: {
          option1: this.SuperSportOption1ValCount,
          option2: this.SuperSportOption2ValCount
        },
        GroupTech: {
          option1: this.GroupTechOption1ValCount,
          option2: this.GroupTechOption2ValCount
        },
        SupportFunctions: {
          option1: this.SupportFunctionsOption1ValCount,
          option2: this.SupportFunctionsOption2ValCount
        }
      };

      // Convert object to array for sorting
      let entries = Object.entries(values);

      // Sort primarily by Option 1, tie-break with Option 2
      entries.sort((a, b) => {
        if (b[1].option1 !== a[1].option1) {
          return b[1].option1 - a[1].option1;
        } else {
          return b[1].option2 - a[1].option2;
        }
      });

      // Assign ranks with tie property
      let rankedEntries = [];
      let currentRank = 1;

      entries.forEach((item, index) => {
        let isTie = false;

        if (
          index > 0 &&
          item[1].option1 === entries[index - 1][1].option1 &&
          item[1].option2 === entries[index - 1][1].option2
        ) {
          // Tie with previous entry
          isTie = true;
          rankedEntries.push({
            name: item[0],
            option1: item[1].option1,
            option2: item[1].option2,
            rank: rankedEntries[rankedEntries.length - 1].rank,
            tie: true
          });
        } else {
          // New rank
          rankedEntries.push({
            name: item[0],
            option1: item[1].option1,
            option2: item[1].option2,
            rank: currentRank,
            tie: false
          });
        }
        currentRank++;
      });
      // Return top 3 with ranks
      return rankedEntries.slice(0, 3);
      return rankedEntries;
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    },
    dateFilters: function () {
      this.validateDates()
      console.log('date filter called', this.fromDate , this.toDate)
      if (this.fromDate && this.toDate) {
        console.log('load nomination called')
          this.loadNominations()
      }
    },
    changeItemPerPage: function () {
      this.currentPage = 0
      this.loadNominations()
    },
    generateSearchQuery: function () {
      let userEmails = []
      if (typeof this.userDetails.email !== 'undefined' && typeof this.userDetails.username !== 'undefined' ) {
        userEmails = this.userDetails.email.toLowerCase()
      } else if (typeof this.userDetails.email !== 'undefined') {
        userEmails = this.userDetails.email.toLowerCase()
      } else if (typeof this.userDetails.username !== 'undefined') {
        userEmails = this.userDetails.username.toLowerCase()
      }
      let offset = Math.max(this.currentPage - 1, 0) * this.itemsPerPage
      console.log(' offset ', offset, this.currentPage, Math.max(this.currentPage - 1,0))
      let string = '?email=' + userEmails+'&type='+this.userType+'&perPage='+this.itemsPerPage+'&offset='+offset
      if (this.nominationCategorySelect === '-- All --'){
        string = string+'&nomination_categories=140'
      } else {
        string = string+'&nomination_categories=' + this.nominationCategorySelect
      }
      if (typeof this.nominationApproverSelect !== 'undefined'){
        string = string+'&approver_categories=' + this.nominationApproverSelect
      }
      if (this.fromDate && this.toDate) {
        console.log(' string  '+string)
        string = string+'&from='+this.fromDate+'&to='+this.toDate
      }
      if (typeof this.selectedBUOption !== 'undefined'){
        string = string+'&BU=' + this.selectedBUOption
      }
      
      console.log('string ', string)
      return string
    },
    loadNominations: function () {
      this.contentReady = false
      console.log(' this.userDetails ', this.userDetails, this.itemsPerPage, this.nominations.length)
      if (this.userDetails.email !== undefined) {
        console.log('before calling userEmails')
        WordpressRestAPI.getCustomViewContent('getNomination/v1/getusernominationForEmployeeAwardMCGEOY'+this.generateSearchQuery())
        .then(response => {
          console.log('review list-> ', response.data)
          if (response.data !== false) {
            console.log(' response.data ', response.data)
            this.nominations = response.data['data']
            //this.totalPageNominations = response.data['data']
            this.totalPosts = response.data['total_post']
          } else {
            this.nominations= []
            this.totalPosts = 0
          }
          this.contentReady = true;
        })
        .catch(e => {
          this.contentReady = true
          this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
          console.error(e)
        })
      }
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      console.log(' newDetails ', newDetails)
      console.log(' oldDetails ', oldDetails)
      this.loadNominations()
    },
    viewMCGEmployeeYearAwardsCountReport (newDetails, oldDetails) {
      console.log('watch viewMCGEmployeeYearAwardsCountReport called')
      if (!this.$store.getters.isAdmin) {
        //this.loadContent()
      }
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
</style>




// WEBPACK FOOTER //
// src/components/routes/VEAwardForMCGEmployeeYearNominationCount.vue